"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _propsToClassKey.default;
  }
});
var _propsToClassKey = _interopRequireDefault(require("./propsToClassKey"));